export default __webpack_public_path__ + "static/media/rocket_anim_79.8387a529.png";